import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

// matchMedia is missing in jsdom and very old browsers: treat as "no preference".
const mediaQuery = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(QUERY)
    : null;

/**
 * True while the OS asks for reduced motion; follows changes live. For JS
 * that decides whether to animate at all — CSS animations are already cut
 * by the global reduced-motion rule in styles/tailwind.css.
 */
export const usePrefersReducedMotion = () => {
  const [reduced, setReduced] = useState(() => Boolean(mediaQuery()?.matches));

  useEffect(() => {
    const mql = mediaQuery();
    if (!mql) return undefined;
    const onChange = () => setReduced(mql.matches);
    onChange();
    // Safari < 14 only has the deprecated addListener/removeListener.
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, []);

  return reduced;
};

export default usePrefersReducedMotion;
